import React, { createContext, useEffect, useRef, useState } from "react";

const USUndoContext = createContext({});

export const USUndoProvider = ({ children }) => {
  const positionEdits = useRef([]);
  const undoList = useRef([]);
  const [editID, setEditID] = useState(0);
  const [editingField, setEditingField] = useState(false);
  const [showcalculator, setShowcalculator] = useState();
  const inputRefs = useRef({});
  const [undoFocusFlag, setUndoFocusFlag] = useState();
  const [reloadpayterms, setReloadpayterms] = useState(false);

  return (
    <USUndoContext.Provider
      value={{
        positionEdits,
        editID,
        setEditID,
        editingField,
        setEditingField,
        undoList,
        showcalculator,
        setShowcalculator,
        inputRefs,
        undoFocusFlag,
        setUndoFocusFlag,
        reloadpayterms,
        setReloadpayterms,
      }}
    >
      {children}
    </USUndoContext.Provider>
  );
};

export default USUndoContext;
